<template>
  <div class="app-container">
    <!-- <Header></Header> -->
    <Table></Table>
    <Pagination></Pagination>
    <dataDialog></dataDialog>
    <detailDialog></detailDialog>
  </div>
</template>

<script>
// import Header from './header'
import Table from './table'
import Pagination from './pagination'
import dataDialog from './dataDialog'
import detailDialog from './detailDialog'

export default {
  data() {
    return {
      moduleName: 'contact'
    }
  },
  components: {
    Table,
    Pagination,
    // Header,
    dataDialog,
    detailDialog
  },
  created() {
    this.$store.commit(`${this.moduleName}/SET_SEARCH_QUERY_DEFAULT`)
    this.$store.dispatch(`${this.moduleName}/GetList`)
  }
}
</script>
